import { channels } from './channels';
import { fileUpload } from './file-upload';
import * as idEndpoints from './id';
import { oauth } from './oauth';
import { id, root } from './social-media';

export const socialMedia = {
  ...root,
  channels,
  fileUpload,
  id: {
    ...id,
    ...idEndpoints,
  },
  oauth,
};
